export class Article {
  constructor(data) {
    this.data = data
  }

  get title() {
    return this.data.title
  }

  get link() {
    return this.data.link
  }

  get excerpt() {
    return this.data.excerpt
  }

  get categories() {
    return this.data.categories
  }

  get highlighted() {
    return this.data.highlighted
  }

  get image() {
    return this.data.image
  }

  get date() {
    return this.data.date
  }

  hasCategory(cat) {
    return this.categories ? !!this.categories.find(c => cat === c) : false
  }
}
